import React , { useState } from 'react';
import { Button } from '../../globalStyles';
import firebase from 'firebase';
import {
  CardWrapper,
  CardBody,
  CardFieldset,
  CardInput,
} from './Contact.elements';

function ContactForm() {
  const [companyName, setcompanyName] = useState("");
  const [companyEmail, setcompantEmail] = useState("");
  const [message, setMessage] = useState("");

  const [loader, setLoader] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoader(true);
      const db = firebase.firestore();

    db.collection("contacts")
      .add({
        companyName: companyName,
        companyEmail: companyEmail,
        message: message,
      })
      .then(() => {
        setLoader(false);
        alert("Your message has been submitted");
      })
      .catch((error) => {
        alert(error.message);
        setLoader(false);
      });

    setcompanyName("");
    setcompantEmail("");
    setMessage("");
  };

  return (
    
      <CardWrapper onSubmit={handleSubmit}>
        <CardBody >
          <CardFieldset>
            <CardInput placeholder="Company Name" type="text" required 
        onChange={(e) => setcompanyName(e.target.value)}/>
          </CardFieldset>

          <CardFieldset>
            <CardInput placeholder="Contact Email" type="text" required         onChange={(e) => setcompantEmail(e.target.value)}
 />
          </CardFieldset>

          <CardFieldset>
            <CardInput className="textarea" placeholder="Message" type="textarea" required         onChange={(e) => setMessage(e.target.value)}
 />
          </CardFieldset>
          <CardFieldset>
            <Button type="submit" primary >Contact Us</Button>
          </CardFieldset> 

          
        </CardBody>
      </CardWrapper>
      

            
  );
}



export default ContactForm;
